const FromArrEditor = [{
		title: "产品线：",
		inputtype: "select",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		event: 'invClassChange'
	},
	{
		title: "授权经销商：",
		// inputtype: "input",
		inputtype: "selectSingle",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'AuthorizedDealer',
		event: 'AuthorizedDealerChange'
	},
	{
		title: "订货经销商：",
		modelvalue: '',
		inputtype: "selectSingle",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		remoteMethod: 'OrderingDealer',
		loading: false,
		options: [],
		event: 'OrderAuthorizedChange'
	},
	{
		title: "授权产品：",
		inputtype: "select",
		SelectType: 'SelectAll',
		checkedSelect: false,
		selectFlag: false,
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		AllName: '全选',
		lableheight: 20,
		X: true,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		multiple: true,
		collapseTags: true,
		event: 'AuthorizedProduct'
	},
	{
		title: "关联产品型号：",
		inputtype: "select",
		SelectType: 'SelectAll',
		checkedSelect: false,
		selectFlag: false,
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		AllName: '全选',
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		multiple: true,
		collapseTags: true,
		event: 'AssociationProduct'
	},
	{
		title: "授权有效日期：",
		StartTime: "",
		EndTime: "",
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "date",
		placeholder: "发布时间",
		widthLeft: 190,
		widthRight: 150,
		disabled: false,
		marginLeft: 15,
		marginTop: 15,
		pickerOptionsFlagStart: '',
		pickerOptionsFlagEnd: '', //Year
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		title: "高层审批：",
		inputtype: "checkedD",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		width: 200,
		height: 32,
		disabled: true,
		marginLeft: 63,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 500,
		checked: false,
	},
	{
		title: "申请理由：",
		inputtype: "input",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: true,
		types: "text",
		placeholder: "请输入",
		width: 840,
		height: 32,
		disabled: false,
		marginLeft: 21,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
	}
];
export default FromArrEditor;

/**,
  {
    title: "负责销售：",
    inputtype: "select",
    modelvalue: '',
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: true,
    types: "",
    placeholder: "请选择",
    width: 190,
    height: 32,
    disabled: false,
    marginLeft: 16,
    marginTop: 8,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
    event: 'invClassChange'
  },*/